export const WRONG = 'WRONG';
export const CORRECT = 'CORRECT';
export const NONE = 'NONE';
